<template>
  <v-content
    :class="[
      'accent',
      $vuetify.breakpoint.smAndUp ? 'px-5' : 'px-3',
    ]"
    v-resize="onResize"
  >
    <v-dialog v-if="courseSelect" v-model="dialogCourse" max-width="600" scrollable>
      <v-card>
        <v-card-title class="headline font-weight-bold flex-nowrap">
          {{ courseSelect.titulo }}
          <v-spacer></v-spacer>
          <v-btn icon @click="courseSelect = undefined; dialogCourse = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle class="d-flex flex-column">
          Para más información escríbenos
          <div class="d-flex align-center">
            <v-icon color="success" class="mr-2">mdi-whatsapp</v-icon>
            <span class="font-weight-bold success--text">{{siteSettings.redes_sociales.whatsapp}}</span>
          </div>
        </v-card-subtitle>
        <v-card-text>
          <v-img v-if="!courseSelect.video" :src="courseSelect.portada" contain></v-img>
          <iframe
            v-else
            style="width: 100%"
            height="409"
            :src="courseSelect.video.replace('watch?v=', 'embed/')"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
          <div class="mt-6 subtitle">{{ courseSelect.descripcion }}</div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCourses" fullscreen scrollable>
      <v-card>
        <v-card-title class="display-2">
          Cursos
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogCourses = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text v-if="typeCourse === 'activos'" class="pt-8 d-flex flex-wrap justify-center">
          <Course
            v-for="(course, index) in coursesActives"
            :key="index"
            :course="course"
            @click.stop="courseSelect = course; dialogCourse = true;"
          />
        </v-card-text>
        <v-card-text
          v-else-if="typeCourse === 'terminados'"
          class="pt-8 d-flex flex-wrap justify-center"
        >
          <Course
            v-for="(course, index) in coursesComplete"
            :key="index"
            :course="course"
            @click.stop="courseSelect = course; dialogCourse = true;"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-container>
      <!-- principal -->
      <v-row
        v-if="siteSettings && siteSettings.pagina_empresa && siteSettings.pagina_empresa.principal"
        class="justify-space-between align-center fill-height"
        :style="{ height: `${windowSize.y - 64}px` }"
      >
        <v-col cols="12" sm="7" md="7" class="mb-10">
          <div class="d-flex mb-5">
            <v-icon size="100" color="success" class="mr-2">mdi-whatsapp</v-icon>
            <div class="d-flex flex-column justify-center">
              <span
                class="headline font-weight-bold grey--text"
              >Comunicate con nosotros y te ayudaremos</span>
              <span
                class="display-1 font-weight-bold success--text"
              >{{siteSettings.redes_sociales.whatsapp}}</span>
            </div>
          </div>
          <p
            :class="[
            $vuetify.breakpoint.mdAndUp ? 'display-3' : 'display-1',
            'font-weight-bold',
            'mb-1',
          ]"
          >{{ siteSettings.pagina_empresa.principal.titulo }}</p>
          <p
            :class="[
              $vuetify.breakpoint.mdAndUp ? 'display-3' : 'display-1',
              'font-weight-thin',
              'mb-8',
            ]"
          >{{ siteSettings.pagina_empresa.principal.subtitulo }}</p>
        </v-col>
        <v-col cols="12" sm="5" v-if="$vuetify.breakpoint.smAndUp" class="text-right">
          <v-img width="900" src="@/assets/home-portada-empresa.svg" contain></v-img>
        </v-col>
      </v-row>
      <!-- companies -->
      <v-row v-if="companies.length">
        <v-col cols="12" class="text-center headline">
          <span
            :class="[
              $vuetify.breakpoint.smAndUp ? 'display-1' : 'headline',
              'font-weight-light',
              'grey--text'
            ]"
          >{{siteSettings.pagina_empresa.empresas ? siteSettings.pagina_empresa.empresas.titulo : 'Empresas asociadas'}}</span>
        </v-col>
        <v-col
          v-if="siteSettings.pagina_postulante.empresas.descripcion"
          cols="12"
          class="text-center mt-2"
        >
          <span
            class="subtitle-1 grey--text"
          >{{siteSettings.pagina_postulante.empresas.descripcion}}</span>
        </v-col>
        <v-col cols="12">
          <InfiniteAutoPlayCarousel :companies="companies" />
        </v-col>
      </v-row>
      <!-- caracteristicas -->
      <v-row
        class="py-10 mb-10 justify-center"
        v-if="siteSettings && siteSettings.pagina_empresa && siteSettings.pagina_empresa.caracteristicas && siteSettings.pagina_empresa.caracteristicas.caracteristicas.length"
      >
        <v-col
          cols="12"
          :class="[
            'text-center',
            $vuetify.breakpoint.smAndUp ? 'title' : 'subtitle',
            'font-weight-light',
            'px-10',
            'ma-auto',
            'mb-9',
          ]"
          style="max-width: 800px"
          v-if="siteSettings.pagina_empresa.caracteristicas.descripcion"
        >{{ siteSettings.pagina_empresa.caracteristicas.descripcion }}</v-col>
        <div
          v-if="siteSettings.pagina_empresa.caracteristicas.caracteristicas && siteSettings.pagina_empresa.caracteristicas.caracteristicas.length"
          class="d-flex flex-wrap"
        >
          <v-col
            v-for="(caracteristicas, index) of siteSettings.pagina_empresa.caracteristicas.caracteristicas"
            :key="index"
            cols="12"
            :sm="siteSettings.pagina_empresa.caracteristicas.caracteristicas.length >= 3
              ? 6
              : siteSettings.pagina_empresa.caracteristicas.caracteristicas.length === 2 ? 6 : 12"
            :lg="siteSettings.pagina_empresa.caracteristicas.caracteristicas.length >= 3
              ? 4
              : siteSettings.pagina_empresa.caracteristicas.caracteristicas.length === 2 ? 6 : 12"
          >
            <div class="d-flex justify-center">
              <v-img width="300" height="250" :src="caracteristicas.imagen" contain></v-img>
            </div>
            <p
              :class="[
                'font-weight-bold',
                $vuetify.breakpoint.smAndUp ? 'headline' : 'title',
              ]"
            >{{ caracteristicas.titulo }}</p>
            <span
              :class="[
                'subtitle',
              ]"
            >{{ caracteristicas.descripcion }}</span>
          </v-col>
        </div>
      </v-row>
      <!-- cursos -->
      <v-row class="pb-10 my-10" v-if="coursesActives && coursesActives.length">
        <v-col>
          <v-container class="pa-0">
            <v-row class="mb-10">
              <v-col class="d-flex align-center pa-0">
                <v-spacer v-if="$vuetify.breakpoint.smAndUp"></v-spacer>
                <span
                  :class="[
                    $vuetify.breakpoint.smAndUp ? 'display-3' : 'display-1',
                    'font-weight-thin',
                  ]"
                >{{siteSettings.pagina_empresa.cursos ? siteSettings.pagina_empresa.cursos.titulo : 'Nuestros cursos'}}</span>
              </v-col>
              <v-col v-if="siteSettings.pagina_empresa.cursos" cols="12" class="text-center mt-2">
                <span
                  class="subtitle-1 grey--text"
                >{{siteSettings.pagina_empresa.cursos.descripcion}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <div
                  :class="[
                    'd-flex', `${$vuetify.breakpoint.mdAndUp ? 'justify-end' : 'justify-center'}`, 'flex-wrap'
                  ]"
                >
                  <Course
                    v-for="(course, index) in coursesActives"
                    v-if="index < 3"
                    :key="index"
                    :course="course"
                    @click.stop="courseSelect = course; dialogCourse = true;"
                  />
                </div>
              </v-col>
            </v-row>
            <v-row v-if="coursesActives.length > 3">
              <v-spacer></v-spacer>
              <v-btn
                @click="typeCourse = 'activos'; dialogCourses = true"
                text
                rounded
                color="primary"
                class="mr-6"
              >
                Ver más
                <v-icon class="ml-2" small>mdi-arrow-right</v-icon>
              </v-btn>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
      <!-- cursos terminados -->
      <v-row class="my-10" v-if="coursesComplete && coursesComplete.length">
        <v-col>
          <v-container class="pa-0">
            <v-row class="mb-10">
              <v-col class="d-flex align-center pa-0">
                <span
                  :class="[
                    $vuetify.breakpoint.smAndUp ? 'display-3' : 'display-1',
                    'font-weight-thin',
                  ]"
                >{{siteSettings.pagina_empresa.cursos_finalizados ? siteSettings.pagina_empresa.cursos_finalizados.titulo : 'Cursos impartidos'}}</span>
              </v-col>
              <v-col
                v-if="siteSettings.pagina_postulante.cursos_finalizados.descripcion"
                cols="12"
                class="text-center mt-2"
              >
                <span
                  class="subtitle-1 grey--text"
                >{{siteSettings.pagina_postulante.cursos_finalizados.descripcion}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <div
                  :class="[
                    'd-flex', `${$vuetify.breakpoint.mdAndUp ? 'justify-start' : 'justify-center'}`, 'flex-wrap'
                  ]"
                >
                  <Course
                    v-for="(course, index) in coursesComplete"
                    v-if="index < 3"
                    :key="index"
                    :course="course"
                    @click.stop="courseSelect = course; dialogCourse = true;"
                  />
                </div>
              </v-col>
            </v-row>
            <v-row v-if="coursesComplete.length > 3">
              <v-spacer></v-spacer>
              <v-btn
                @click="typeCourse = 'terminados'; dialogCourses = true"
                text
                rounded
                color="primary"
                class="mr-6"
              >
                Ver más
                <v-icon class="ml-2" small>mdi-arrow-right</v-icon>
              </v-btn>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import { mapState } from "vuex";

import CardNotice from "@/components/CardNotice";

import InfiniteAutoPlayCarousel from "@/components/InfiniteAutoPlayCarousel";
import Course from "@/components/Course.vue";
import Footer from "@/components/Footer.vue";
import { windowSizeMixin } from "@/mixin/windowSizeMixin.js";

import store from "@/store";

export default {
  mixins: [windowSizeMixin],
  name: "Home",
  components: {
    CardNotice,
    Course,
    Footer,
    InfiniteAutoPlayCarousel
  },
  data() {
    return {
      dialogCourse: false,
      dialogCourses: false,
      courseSelect: undefined,
      typeCourse: "",
      companies: []
    };
  },
  computed: {
    ...mapState(["siteSettings", "courses"]),
    coursesActives() {
      return this.courses ? this.courses.filter(course => course.estado) : [];
    },
    coursesComplete() {
      return this.courses ? this.courses.filter(course => !course.estado) : [];
    }
  },
  created() {
    this.retrieveCompanies();
    this.retrieveCourses();
  },
  methods: {
    retrieveCourses() {
      if (!this.courses) {
        store
          .dispatch("retrieveCourses")
          .then(() => {})
          .finally(() => {});
      }
    },
    retrieveCompanies() {
      store
        .dispatch("retrieveCompanies")
        .then(companies => {
          this.companies = companies;
        })
        .finally(() => {});
    }
  }
};
</script>
